/**
 * Dokumentácia chybových stavov streamu z kamery
 * Reálne logy z konzoly hornej obrazovky zo sportboxu: SB1913045 Pivnica-Tvrdošín, Tvrdošín
 * 
 * Tento súbor obsahuje príklady rôznych stavov MediaStreamTrack
 * pre účely debugovania a testovania.
 */

// ===================================================================
// PRÍPAD 1: Stream s muted=true (kamera zamrznutá)
// ===================================================================

// Získané pomocou: document.querySelector('#biometryContainer video').srcObject.getVideoTracks()
// [MediaStreamTrack] 0:

const frozenStreamExample = {
    contentHint: "",
    enabled: true,
    id: "d4eac611-5c6f-42d3-b70c-7707d030914f",
    kind: "video",
    label: "USB Camera (0bda:3035)",
    muted: true,  // POZOR: muted=true indikuje zamrznutý stream
    oncapturehandlechange: null,
    onended: null,
    onmute: null,
    onunmute: null,
    readyState: "live"
};

// ===================================================================
// PRÍPAD 2: Stream po reload - čierna obrazovka (readyState="ended")
// ===================================================================
const blackScreenAfterReloadExample = {
    contentHint: "",
    enabled: true,
    id: "2008ed86-a672-4e70-b54e-04bd0eeeda10",
    kind: "video",
    label: "USB Camera (0bda:3035)",
    muted: false,
    oncapturehandlechange: null,
    onended: null,
    onmute: null,
    onunmute: null,
    readyState: "ended"  // POZOR: readyState="ended" = ukončený stream
};

// ===================================================================
// PRÍPAD 3: Normálne fungujúci stream
// ===================================================================
const normalStreamExample = {
    contentHint: "",
    enabled: true,
    id: "6c972e2e-fff2-40bb-86df-69b257a6312b",
    kind: "video",
    label: "USB Camera (0bda:3035)",
    muted: false,  // OK: muted=false
    oncapturehandlechange: null,
    onended: null,
    onmute: null,
    onunmute: null,
    readyState: "live"  // OK: readyState="live"
};

// ===================================================================
// KĽÚČOVÉ INDIKÁTORY PROBLÉMOV:
// ===================================================================
// 1. muted: true && readyState: "live" → zamrznutý stream
// 2. readyState: "ended" → ukončený stream, čierna obrazovka
// 3. enabled: false → track je deaktivovaný
// ===================================================================